<footer class="app-footer">
  <span class="copy">&copy; {{ year }} statsboard.ru</span>
  <div class="versions" aria-label="Running versions">
    <span [title]="buildInfo.frontendTitle">Frontend: {{ buildInfo.frontendLabel }}</span>
    <span [title]="buildInfo.backendTitle()">Backend: {{ buildInfo.backendLabel() }}</span>
  </div>
  <nav class="links">
    <a routerLink="/privacy">Privacy</a>
    <span class="sep" aria-hidden="true">·</span>
    <a routerLink="/cookies">Cookies</a>
  </nav>
</footer>
